import { getLambdaLink } from '@common/utils';

interface ImageAndTextItem {
  id: number;
  heading: string;
  paragraph: string;
}

interface ImageAndText {
  id: number;
  name: string;
  ctaLink: string;
  ctaText: string;
  showCta: boolean;
  texts: Array<ImageAndTextItem>;
  images: Array<string>;
}

const aspectRatioMultiplier = 1;

export const aspectRatioImages = {
  ImageText1: { width: 1440, height: 810 },
  ImageText2: { width: 1440, height: 1080 },
  ImageText3: { width: 1440, height: 1800 },
  ImageText4: { width: 1440, height: 810 },
  ImageText5: { width: 1440, height: 810 },
  ImageText6: { width: 720, height: 720 },
  ImageText7: { width: 800, height: 800 },
};

export const processResponse = (imageAndText: Record<string, unknown>): ImageAndText => {
  const { width, height } = aspectRatioImages[imageAndText?.layout?.name] || { width: 0, height: 0 };
  return {
    id: imageAndText.id,
    name: imageAndText.name,
    ctaLink: imageAndText.cta_link,
    ctaText: imageAndText.cta_text,
    showCta: imageAndText.show_cta,
    texts: imageAndText.texts.map((text: Record<string, number | string>) => {
      return {
        id: text.id,
        heading: text.heading,
        paragraph: text.paragraph,
      };
    }),
    images: imageAndText.images?.map((imageObject) => {
      return decodeURIComponent(
        getLambdaLink({
          link: imageObject.image_url as string,
          width: width * aspectRatioMultiplier,
          height: height * aspectRatioMultiplier,
        }),
      );
    }),
    layout: imageAndText.layout,
  };
};
